import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import './assets/css/reset.css'
import '../static/css/reset.css'
import '../static/iconfont/iconfont.js'


import router from './router/index.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
import GeminiScrollbar from 'vue-gemini-scrollbar'
// video
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
const hls = require('videojs-contrib-hls')

// 放大镜
import VuePhotoZoomPro from "vue-photo-zoom-pro"

import handle from './handle.js'
import Util from './util/util.js'
import socket from './util/im.js'

// axios
import axios from 'axios'
import store from './vuex/store'
import siteinfo from './util/siteinfo.js'
import {
    Message,
    Loading,
    MessageBox
} from 'element-ui'

Vue.use(hls)
Vue.use(VideoPlayer)
Vue.use(GeminiScrollbar)
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.use(VuePhotoZoomPro)
var HTTP = axios.create({
    baseURL: siteinfo.siteinfo.siteroot,
    // timeout: 5000,
    responseType: 'json',
    headers: {
        'token': localStorage.getItem('Token') || '',
        'pid': localStorage.getItem('uniacid') || siteinfo.siteinfo.uniacid,
        'content-type': 'application/json; charset=utf-8;' //转换为key=value的格式必须增加content-type
    },
})

Vue.prototype.$http = HTTP
Vue.prototype.$handle = handle
Vue.prototype.sendMsg = socket.sendMsg
Vue.prototype.$util = new Util()

new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    render: h => h(App),
    template: '<App/>'
})

// 判断请求的连接是否需要token
Vue.prototype.checkLogin = function() {
    let t = this, token = localStorage.getItem('Token')
    if (token === null || !token) {
        MessageBox.confirm('您还没有登录,请先去登录', '提示', {
            confirmButtonText: '立即登录',
            cancelButtonText: '暂不登录',
            type: 'warning',
            center: true
        }).then(() => {
            t.$router.push('/signin')
        })
        return false
    }
    return true
}

// 全局守卫
router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    window.pageYOffset = 0
    next()
})



// WEBPACK FOOTER //
// ./src/main.js